
import styles from './Policy.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import common from '../../../common';


function Policy() {

    return (
        <>
            <div className="temp_bg">
                <span>개인정보처리방침</span>
            </div>
            <div className="components_wrap">
                <span className='components_wrap_title'>개인정보처리방침</span>
                <div className={styles.policy_cont} dangerouslySetInnerHTML={{
                            __html: `
한국공학한림원 차세대공학리더('www.naekyehs.org', 이하 ‘YEHS')는 회원의 개인정보보호를 중요시하며, 개인정보 보호법 제30조에 따라 정보주체의 개인정보가 개인정보보호를 위한 조치와 어떠한 용도와 방식으로 이용되고 있는지 설명하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립․공개합니다. YEHS의 개인정보처리방침은 정부의 법률 및 지침 변경이나, YEHS의 내부 방침 변경 등으로 인하여 개정하는 경우 변경사항에 대하여 즉시 홈페이지를 통하여 게시하고 있습니다. 본 방침은 2024년 12월 1일부터 시행됩니다.

### 제1조(개인정보의 처리목적)

YEHS는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 홈페이지 회원 가입 및 관리

회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별.인증, 회원자격 유지.관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지.통지, 고충처리, 한국공학한림원 공학기술진 사업을 기반으로 한 회원 간 네트워크를 형성 등을 목적으로 개인정보를 처리합니다.

2. 재화 또는 서비스 제공

물품배송, 서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제.정산 등을 목적으로 개인정보를 처리합니다.

3. 고충처리

민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락 및 통지, 처리결과 통보 등의 목적으로 개인정보를 처리합니다.

4. 마케팅 및 광고에의 활용

신규서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.

### 제2조(개인정보의 처리 및 보유기간)

① YEHS는 법령에 따른 개인정보 보유․이용기간 또는 정보주체로부터 개인정보를 수집시에 동의받은 개인정보 보유.이용기간 내에서 개인정보를 처리.보유합니다.

② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

1. 홈페이지 회원 가입 및 관리 : 서비스 이용에 차질이 없도록 홈페이지 탈퇴 및 회원에 의해 기록된 프로필 삭제 요청이 없는 한 보관하고 있습니다.

다만, 탈퇴 및 회원의요청이 있는 경우라 하더라도 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지 정보를 보관합니다.

1) 관계 법령 위반에 따른 수사․조사 등이 진행중인 경우에는 해당 수사․조사 종료시까지

2) 홈페이지 이용에 따른 채권․채무관계 잔존시에는 해당 채권․채무관계 정산시까지

2. 이벤트나 경품행사 등 서비스 제공 : 행사.재화.서비스 공급완료 및 요금결제.정산 완료시까지
    다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료시까지

1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시․광고, 계약내용 및 이행 등 거래에 관한 기록

- 표시.광고에 관한 기록 : 6개월
- 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년
- 불만 또는 분쟁처리에 관한 기록 : 3년

### 제3조(개인정보의 제3자 제공)

① YEHS는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.

② YEHS는 개인정보 처리를 위하여 회원 외 제3자에게 제공하고 있지 않습니다.

### 제4조(개인정보처리의 위탁)

① YEHS는 개인정보 업무처리를 위하여 개인정보 처리업무를 위탁하여 운영하고 있지 않습니다.

② 위탁업무에 대한 방침이 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

### 제5조(정보주체의 권리.의무 및 행사방법)

① 정보주체는 YEHS에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.

1. 개인정보 열람요구

2. 오류 등이 있을 경우 정정 요구

3. 삭제요구

4. 처리정지 요구

② 제1항에 따른 권리 행사는 YEHS에 대해 서면, 전화, 전자우편 등을 통하여 하실 수 있으며 YEHS는 이에 대해 지체없이 조치하겠습니다. 또한 개인정보 주체는 언제든지 본인의 개인정보를 열람, 정정할 수 있으며, 자유롭게 정보수신 상태를 변경할 수 있습니다.

③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 YEHS는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.

④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.

⑤ 정보주체는 개인정보 보호법 등 관계법령을 위반하여 YEHS가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니됩니다.

### 제6조(처리하는 개인정보 항목)

YEHS는 서비스 제공을 위해 회원에 대한 필요한 다음의 개인정보 항목을 수집 처리하고 있습니다.

1. 홈페이지 회원 가입 및 관리

- 필수항목 : 성명, 생년월일, 아이디, 비밀번호, 주소, 휴대전화번호, 이메일주소, 학교, 학과
- 선택항목 : 사진, 회사명, 업계, 직책, 부서, 취미 및 관심사

2. 이벤트나 경품행사 등 서비스 제공

- 필수항목 : 성명, 생년월일, 휴대전화번호, 이메일주소, 소속(회사.학교), 사진

3. 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.

- IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등

### 제7조(개인정보의 파기)

① YEHS는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.

② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.

③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.

1. 파기절차

YEHS는 파기 사유가 발생한 개인정보를 선정하고, YEHS의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다. 제공하셨던 모든 개인정보 및 프로필 등의 정보가 삭제되며 삭제된 정보는 복구가 불가능합니다.

2. 파기방법

YEHS는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할 수 없도록 내부 내용 수정 저장, 동일 이름 덮어쓰기 후 삭제 등의 방법을 이용하여 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.

### 제8조(개인정보의 안전성 확보조치)

YEHS는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적.관리적 및 물리적 조치를 하고 있습니다.

① 개인정보 취급 운영진의 최소화 및 교육

개인정보를 취급하는 담당을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.

② 내부관리계획의 수립 및 시행

개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.

③ 개인정보에 대한 접근 제한

개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 통제를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 IP인증시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.

④ 개인정보의 암호화

이용자의 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.

⑤ 문서보안 사항 준수

개인정보가 포함된 서류 등을 무단으로 생산하지 않으며 운영진에 의한 관리 및 보관이 이뤄지고 있습니다.

### 제9조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항)

① YEHS는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.

② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.

가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.

나. 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.

다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.

### 제10조(개인정보 보호책임자)

① YEHS는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자

성명 : 김민영

직책 : 회장

연락처 : minyoung.kim@yehs.or.kr

② 정보주체께서는 YEHS의 서비스(또는 행사)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. YEHS는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.

### 제11조(개인정보 열람청구)

정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. YEHS는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.

▶ 개인정보 열람청구 접수․처리 부서

부서명 : 홍보부, 회원관리부

담당자 : 문서영, 정성헌

연락처 : contact@yehs.or.kr

### 제12조 (이메일 주소 무단 수집 거부)

YEHS는 개인의 이메일 주소 무단 수집을 거부합니다. YEHS의 웹사이트, 기타 서비스를 통해 게시되거나 공개된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망 법 제50조 2항에 의해 형사처벌 됨을 유념하시기 바랍니다.

정보통신망법 제50조의2 (전자우편주소의 무단 수집행위 등 금지)

① 누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.

② 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니된다.

③ 누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보전송에 이용하여서는 아니된다.

### 제13조(권익침해 구제방법)

정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.

<아래의 기관은 YEHS와는 별개의 기관으로서, YEHS의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다>

- 개인정보 침해신고센터 (한국인터넷진흥원 운영)
    - 소관업무 : 개인정보 침해사실 신고, 상담 신청
    - 홈페이지 : privacy.kisa.or.kr
    - 전화 : (국번없이) 118
    - 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터
- 개인정보 분쟁조정위원회
    - 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
    - 홈페이지 : www.kopico.go.kr
    - 전화 : (국번없이) 1833-6972
    - 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층
- 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr)
- 경찰청 사이버안전국 : 182 (http:..cyberbureau.police.go.kr)

### 제14조(개인정보 처리방침 변경)

① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
`}} />
            </div>
        </>
    );
}

export default Policy;